// extracted by mini-css-extract-plugin
module.exports = {"title":"reportSalary_title__3xZ0r"};